import React from 'react'
import './Notifications.scss'

const Notifications = () => {
  return (
    <div>Notifications</div>
  )
}

export default Notifications